import {CustomerFieldKeys, getValue} from '../../../support/get_data';
import {useAppSelector} from '../../../store/store';
import {__, transString} from '../../../support/lang/translations';
import {useIsNavigatingOrPending} from '../../../support/use_is_navigating_or_pending';
import formStyles from '../../../components/form/form.module.scss';
import {classNames} from '../../../support/classnames';
import {Button} from '../../../components/button/button';
import {ButtonColorType} from '../../../enums/button_color_type.ts';
import {LanguageSelect} from '../../../components/language_select/language_select.tsx';
import {DefaultLocationSelect} from '../../../components/default_location_select/default_location_select.tsx';
import {useState} from 'react';
import buttonStyles from '../../../components/button/button.module.scss';

export function PersonalDetailsTitle() {
    const meInfo = useAppSelector((state) => state.customerInfo.me);
    const meData = meInfo?.customer;

    const nameData = getValue(meData, CustomerFieldKeys.NAME);

    return (
        <>
            <h1>
                {nameData?.value != null
                    ? __('onboarding.personal_details.title_name', {name: nameData?.value})
                    : __('onboarding.personal_details.title_unknown')}
            </h1>
            <h2>{__('onboarding.personal_details.subtitle')}</h2>
        </>
    );
}

interface ContentProps {
    isEditing: boolean;
    onEditClick: () => void;
    setCanSubmit: (value: boolean) => void;
}
export function PersonalDetailsContent(props: ContentProps) {
    const isLoading = useIsNavigatingOrPending((state) => state.customerInfo.status);
    const meInfo = useAppSelector((state) => state.customerInfo.me);
    const meData = meInfo?.customer;

    const nameData = getValue(meData, CustomerFieldKeys.NAME);
    const prepositionData = getValue(meData, CustomerFieldKeys.PREPOSITION);
    const surNameData = getValue(meData, CustomerFieldKeys.SURNAME);
    const birthDayData = getValue(meData, CustomerFieldKeys.BIRTHDAY);

    const [firstName, setFirstName] = useState(nameData?.value ?? '');
    const [lastName, setLastName] = useState(surNameData?.value ?? '');

    function checkDataForSubmit() {
        console.log(firstName);
        console.log(lastName);
        props.setCanSubmit(firstName.length > 0 && lastName.length > 0);
    }

    return (
        <>
            <h2>{__('onboarding.personal_details.content_title')}</h2>

            <div className={formStyles.form} onClick={() => props.onEditClick()}>
                <div className={formStyles.form__grid}>
                    <div className={formStyles.grid__custom}>
                        <fieldset>
                            <legend data-grid-column-start={1} data-grid-column-end={13}>
                                {__('profile.fields.full_name')}
                            </legend>
                            <input
                                className={classNames({[formStyles.locked]: !props.isEditing})}
                                data-grid-column-start={1}
                                data-grid-column-end={7}
                                defaultValue={nameData?.value ?? ''}
                                placeholder={nameData?.name ?? transString('profile.fields.name')}
                                name={nameData?.key ?? CustomerFieldKeys.NAME}
                                disabled={isLoading}
                                onChange={(e) => {
                                    setFirstName(e.target.value);
                                }}
                                onBlur={() => {
                                    checkDataForSubmit();
                                }}
                            />
                            <input
                                className={classNames({[formStyles.locked]: !props.isEditing})}
                                data-grid-column-start={7}
                                data-grid-column-end={9}
                                defaultValue={prepositionData?.value ?? ''}
                                placeholder={transString('profile.fields.preposition')}
                                name={prepositionData?.key ?? CustomerFieldKeys.PREPOSITION}
                                disabled={isLoading}
                            />
                            <input
                                className={classNames({[formStyles.locked]: !props.isEditing})}
                                data-grid-column-start={9}
                                data-grid-column-end={13}
                                defaultValue={surNameData?.value ?? ''}
                                placeholder={surNameData?.name ?? transString('profile.fields.name')}
                                name={surNameData?.key ?? CustomerFieldKeys.SURNAME}
                                disabled={isLoading}
                                onChange={(e) => {
                                    setLastName(e.target.value);
                                }}
                                onBlur={() => {
                                    checkDataForSubmit();
                                }}
                            />
                        </fieldset>
                    </div>
                </div>

                <div className={formStyles.form__grid}>
                    <div className={formStyles.grid__default}>
                        <label>
                            {birthDayData?.name ?? __('profile.fields.birthday')}
                            <input
                                className={classNames({[formStyles.locked]: !props.isEditing})}
                                defaultValue={birthDayData?.value ?? ''}
                                name={birthDayData?.key ?? CustomerFieldKeys.BIRTHDAY}
                                disabled={isLoading}
                                type="date"
                            />
                        </label>
                    </div>

                    <div className={formStyles.grid__default}>
                        <LanguageSelect isLoading={isLoading} isLocked={!props.isEditing} />
                        <DefaultLocationSelect isLoading={isLoading} isLocked={!props.isEditing} />
                    </div>
                </div>
            </div>
        </>
    );
}

interface FooterProps {
    isEditing: boolean;
    setIsEditing: (isEditing: boolean) => void;
    onNextSlide: () => void;
    canSubmit: boolean;
}

export function PersonalDetailsFooter(props: FooterProps) {
    return (
        <>
            <div>
                {props.isEditing ? (
                    <span />
                ) : (
                    <div>
                        <Button
                            className={buttonStyles.button_step}
                            type="button"
                            onClick={() => props.setIsEditing(true)}
                            colorType={ButtonColorType.Black}
                        >
                            <i className="fa-light fa-x" />
                            <span>{__('onboarding.personal_details.buttons.invalid')}</span>
                        </Button>
                    </div>
                )}
            </div>
            <div>
                <Button
                    className={buttonStyles.button_step}
                    type="button"
                    onClick={() => props.onNextSlide()}
                    colorType={ButtonColorType.Green}
                    disabled={props.isEditing && !props.canSubmit}
                >
                    <i className="fa-light fa-check" />
                    {props.isEditing ? (
                        <span>{__('onboarding.personal_details.buttons.next')}</span>
                    ) : (
                        <span>{__('onboarding.personal_details.buttons.valid')}</span>
                    )}
                </Button>
            </div>
        </>
    );
}
